import React from "react";
import { Box, Container, Typography, CssBaseline } from "@mui/material";
import ChatSidebar from "./ChatSidebar";
import ChatWindow from "./ChatWindow";

export default function AiChatPage() {
  return (
    <Box
      sx={{
        // Отступ сверху для вашего Header
        paddingTop: "40px", // (Было 80px) Оставляем для хедера
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "grey.100", // Фон страницы
      }}>
      <CssBaseline />
      {/* --- 1. ИСПРАВЛЕНИЕ: maxWidth="lg" --- */}
      <Container
        maxWidth="lg" // <-- ИЗМЕНЕНО С 'xl' НА 'lg'
        sx={{
          height: "calc(100% - 16px)", // Оставляем небольшой отступ снизу
          display: "flex", // Убираем padding на lg, т.к. Box будет управлять этим
          mb: 2,
        }}>
        {/* --- ЛЕЙАУТ: Слева Сайдбар, Справа Чат --- */}
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "80%",
            // 2. Добавляем рамку и тень, как в Gemini
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 3,
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            overflow: "hidden", // Чтобы скруглить углы у дочерних элементов
          }}>
          {/* 1. САЙДБАР */}
          <ChatSidebar />

          {/* 2. ОКНО ЧАТА */}
          <ChatWindow />
        </Box>
      </Container>
    </Box>
  );
}
